import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState } from 'app/store/app.states';
import { DialogNewObservationComponent } from './dialog-new-observation/dialog-new-observation.component';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'settings-observations',
  templateUrl: './observations.component.html',
  styleUrls: ['./observations.component.scss']
})
export class SettingsObservationsComponent implements OnInit, OnChanges {
  @Input() idEmpresa;
  descargarExcel: boolean = true;
  objetoGridConfiguration: any;
  nombreReporte: string;
  objetosSelected: any;
  datosevent: any;
  verGrid: boolean = false;

  constructor(
    private coalService: CoalService,
    private store: Store<AppState>,
    private dialog: MatDialog
  ) {
    this.ObjectGrid();
  }
  ngOnInit(): void {
    this.getObservations();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("🚀 ~ SettingsObservationsComponent ~ ngOnChanges ~ changes:", changes)

    if (changes?.idEmpresa?.currentValue) {
      this.getObservations();
    }
  }

  receiveMessage(event) {
    console.log("🚀 ~ SettingsObservationsComponent ~ receiveMessage ~ event:", event)
  }
  Actualizar(event) {
    console.log("🚀 ~ SettingsObservationsComponent ~ Actualizar ~ event:", event)
  }
  modificar(event) {
    console.log("🚀 ~ SettingsObservationsComponent ~ modificar ~ event:", event)
  }
  eliminar(event) {
    console.log("🚀 ~ SettingsObservationsComponent ~ eliminar ~ event:", event)
  }

  getObservations() {
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate=ope_empresa_observacions`)
      .subscribe((res: any) => {
        console.log("🚀 ~ SettingsObservationsComponent ~ .subscribe ~ res:", res)
        this.verGrid = true;
        this.store.dispatch(OcultarSpinner());
        this.objetoGridConfiguration.Data = res.data[0].attributes?.ope_empresa_observacions?.data || [];
      }, (error: any) => {
        this.store.dispatch(OcultarSpinner());
      });
  }

  newObservation(data) {
    const dialogNewObs = this.dialog.open(DialogNewObservationComponent, {
      width: '700px',
      data: { ...data, idEmpresa: this.idEmpresa },
      disableClose: true
    });

    dialogNewObs.afterClosed().subscribe((result) => {
      console.log("🚀 ~ SettingsObservationsComponent ~ dialogNewObs.afterClosed ~ result:", result)

      if (result.success == 1) {
        this.getObservations();
      }
    });
  }

  setDefault() {
    let defualt = this.datosevent[0]?.attributes.default;
    let name = this.datosevent[0]?.attributes.nombre;
    let isDefualt = Boolean(defualt || false);
    let mensaje = '';
    let setDefualt: boolean = false;
    if (isDefualt) {
      //this.objetoGridConfiguration.ToolBox[0].options.text = 'Quitar Predeterminado';
      mensaje = `¿Desea quitar a la observacion de nombre: ${name} como predeterminada?`;
      setDefualt = false;
    } else {
      //this.objetoGridConfiguration.ToolBox[0].options.text = 'Hacer Predeterminado';
      mensaje = `¿Desea hacer predeterminada la observacion de nombre: ${name}?`;
      setDefualt = true;
    }
    const dialogConfirm = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: mensaje
    });
    dialogConfirm.afterClosed().subscribe((result) => {

      if (result) {
        let params = {
          data: {
            default: setDefualt,
            ope_empresa: this.idEmpresa
          }
        }
        if (this.datosevent[0]?.id) {
          this.store.dispatch(MostrarSpinner());
          this.coalService.putService(`ope-empresa-observaciones/${this.datosevent[0].id}`, params)
            .subscribe((res: any) => {
              this.getObservations();
              this.store.dispatch(OcultarSpinner());
            }, (error: any) => {
              this.store.dispatch(OcultarSpinner());
            });
        }
      }
    });

  }

  noSetDefault() {

    const dialogConfirm = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: '¿Desea quitar la observación de nombre: ' + this.datosevent[0]?.attributes.nombre + ' como predeterminada?'
    });
    dialogConfirm.afterClosed().subscribe((result) => {

      if (result) {
        let params = {
          data: {
            default: false,
            ope_empresa: this.idEmpresa
          }
        }
        if (this.datosevent[0]?.id) {
          this.store.dispatch(MostrarSpinner());
          this.coalService.putService(`ope-empresa-observaciones/${this.datosevent[0].id}`, params)
            .subscribe((res: any) => {
              this.getObservations();
              this.store.dispatch(OcultarSpinner());
            }, (error: any) => {
              this.store.dispatch(OcultarSpinner());
            });
        }
      }
    });

  }

  modify() {
    const dialogRef = this.dialog.open(DialogNewObservationComponent, {
      width: '700px',
      data: this.datosevent[0],
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("🚀 ~ SettingsObservationsComponent ~ dialogRef.afterClosed ~ result:", result)

      if (result.success == 1) {
        this.getObservations();
      }
    });
  }

  delete() {
    const dialogConfirm = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: '¿Desea eliminar la observación de nombre: ' + this.datosevent[0]?.attributes.nombre + '?'
    });
    dialogConfirm.afterClosed().subscribe((result) => {

      if (result) {
        let params = {
          data: {
            default: true,
            ope_empresa: this.idEmpresa
          }
        }
        if (this.datosevent[0]?.id) {
          this.store.dispatch(MostrarSpinner());
          this.coalService.deleteService(`ope-empresa-observaciones/`, this.datosevent[0].id)
            .subscribe((res: any) => {
              this.getObservations();
              this.store.dispatch(OcultarSpinner());
            }, (error: any) => {
              this.store.dispatch(OcultarSpinner());
            });
        }
      }
    });

  }

  datosMessage($event) {
    this.datosevent = $event.data;
  }

  ObjectGrid() {
    let that = this;
    this.nombreReporte = 'Observaciones';
    this.objetoGridConfiguration = {
      GridOptions: {
        paginacion: 20,
        pageSize: ['40', '60', '80', '100'],
      },
      ExportExcel: { enabled: true, fileName: 'Historico' },
      ColumnHiding: { hide: true },
      Checkbox: { checkboxmode: 'single' },
      Editing: { allowupdate: true, mode: 'cell' },
      Columnchooser: { columnchooser: true },
      SearchPanel: {
        visible: true,
        width: 200,
        placeholder: 'Buscar...',
        filterRow: true,
      },
      Scroll: { mode: 'infinite' },
      Color: null,
      Detail: { detail: true },
      ToolbarDetail: null,
      ToolBox: [
        {
          location: 'after',
          widget: 'dxButton',
          locateInMenu: 'auto',
          options: {
            width: 140,
            onClick: this.setDefault.bind(this),
            text: 'Predeterminado'
          },
          visible: true,
          name: 'simple',
        },
        {
          location: 'after',
          widget: 'dxButton',
          locateInMenu: 'auto',
          options: {
            width: 60,
            onClick: this.modify.bind(this),
            icon: '../../../assets/icons/ver.png',
          },
          visible: true,
          name: 'simple',
        },
        {
          location: 'after',
          widget: 'dxButton',
          locateInMenu: 'auto',
          options: {
            width: 60,
            icon: '../../../assets/icons/borrar.png',
            onClick: this.delete.bind(this),
          },
          visible: true,
          name: 'simple',
        },
      ],
      Columns: [],
      Data: [],
      Columns1: [1],
      Data1: [],
      datosMessage(evento) {
        that.objetosSelected = evento.data;
      },
    };
    this.DataColumnsGrid();
  }

  DataColumnsGrid() {
    let columnsMulti = [];
    columnsMulti.push({
      caption: 'Nombre',
      dataField: 'attributes.nombre',
      allowEditing: false,
      fixed: true,
    });
    columnsMulti.push({
      caption: 'Observación',
      dataField: 'attributes.observacion',
      allowEditing: false,
    });
    columnsMulti.push({
      caption: 'Predeterminado',
      dataField: 'attributes.default',
      dataType: 'boolean',
      allowEditing: false,
    });
    this.objetoGridConfiguration.Columns = columnsMulti;
  }

}
